import { render } from "./StoreFooter.vue?vue&type=template&id=212ab010"
import script from "./StoreFooter.vue?vue&type=script&lang=js"
export * from "./StoreFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__